import angular from 'angular';
import menuComponent from './app-menu.component';
import './app-menu.scss';

export default angular.module('common.app-menu', [])
  .component('appMenu', menuComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/common/app-menu/app-menu.module.js